var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lcc",attrs:{"data-nosnippet":""}},[_c('img',{staticClass:"lcc-img",attrs:{"src":_vm.ImageBase64,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"lcc-text",attrs:{"data-nosnippet":""}},[_vm._v(" "+_vm._s(`${_vm.name.repeat(10)} ${_vm.name.repeat(10)}`.repeat(30))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }